import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatDialogModule} from '@angular/material/dialog';

import {ModalInfoComponent} from './modal-info.component';
import {ModalHeaderModule} from '../modal-header/modal-header.module';
import {ImagePathModule} from '@core/pipes/image-path/image-path.module';
import {TranslateModule} from '@core/pipes/translate/translate.module';
import {IsArrayModule} from '@core/pipes/is-array/is-array.module';


@NgModule({
  declarations: [
    ModalInfoComponent
  ],
  imports: [
    CommonModule,
    ModalHeaderModule,
    MatDialogModule,
    ImagePathModule,
    TranslateModule,
    IsArrayModule
  ],
  exports: [
    ModalInfoComponent
  ]
})
export class ModalInfoModule {
}
